module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-outer-71aab4e2.svg";